<mg-table [collectionComponent]="this" matSort stickyHeaders stickyHeaders>

	<ng-container matColumnDef="relatie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Relatie</th>
        <td mat-cell *matCellDef="let row"> {{row.relatie.naam1}} </td>
    </ng-container>

	<ng-container matColumnDef="groep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Groep </th>
        <td mat-cell *matCellDef="let row"> {{getGroep(row.groep)}} </td>
    </ng-container>

    <ng-container matColumnDef="soort">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Soort </th>
        <td mat-cell *matCellDef="let row"> {{row.soort}} </td>
    </ng-container>

	<ng-container matColumnDef="merk">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Merk </th>
        <td mat-cell *matCellDef="let row"> {{row.merk}} </td>
    </ng-container>

	<ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let row"> {{row.type}} </td>
    </ng-container>

	<ng-container matColumnDef="nr_Instrument">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nr Instrument </th>
        <td mat-cell *matCellDef="let row"> {{row.nr_Instrument}} </td>
    </ng-container>

	<ng-container matColumnDef="nr_Fabriek">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nr Serie/Fabriek </th>
        <td mat-cell *matCellDef="let row"> {{row.nr_Fabriek}} </td>
    </ng-container>

	<ng-container matColumnDef="nr_Barcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Barcode </th>
        <td mat-cell *matCellDef="let row"> {{row.nr_Barcode}} </td>
    </ng-container>

	<ng-container matColumnDef="nr_Referentie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nr Referentie </th>
        <td mat-cell *matCellDef="let row"> {{row.nr_Referentie}} </td>
    </ng-container>

	<ng-container matColumnDef="lokatie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Locatie </th>
        <td mat-cell *matCellDef="let row"> {{row.lokatie}} </td>
    </ng-container>

    <ng-container matColumnDef="centixId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centix </th>
        <td mat-cell *matCellDef="let row"> {{row.centixId}} </td>
    </ng-container>

    <ng-container matColumnDef="isVervallen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Vervallen </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isVervallen">done</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="isVerlopen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Verlopen </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isVerlopen">done</mat-icon></td>
    </ng-container>

    <ng-container matColumnDef="isWerkstandaard">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Werkstandaard </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.isWerkstandaard">done</mat-icon></td>
    </ng-container>
    
</mg-table>
